<script lang="ts">
    import KpValueEditorForceSettings from '../../commons/value-editors/kp-value-editor-force-settings/KpValueEditorForceSettings.svelte';
    import KpValueEditor from '../../commons/value-editors/kp-value-editor/KpValueEditor.svelte';
    import type {ForceSetting} from '../../commons/value-editors/kp-value-editor-force-settings/types';
    import type {FormControlOptions} from '../../commons/value-editors/internal/forms/types';
    import {ValueEditorSize} from '../../commons/value-editors/types';
    import type {Observable} from 'rxjs';
    import type {Field as SvelteFormsField} from 'node_modules/svelte-forms/types';
    import type {FormController} from '../../commons/value-editors/internal/forms/types';
    import {createEventDispatcher, onMount} from 'svelte';
    import type {EditableField, EditableFieldType} from '../../typings/portaro.be.types';

    export let forceSettings: ForceSetting[] = [];
    export let fieldOrSubfieldType: EditableFieldType;
    export let field: EditableField;
    export let showRecordLink = false;

   const dispatch = createEventDispatcher<{'field-value-submit': void}>();

    const formControlOptions: FormControlOptions = {updateTriggers: [{eventName: 'input', debounceValue: 1500}, {eventName: 'blur', debounceValue: 0}]}
    const editorSize = ValueEditorSize.SM;


    let editorController;
    let formField$: Observable<SvelteFormsField<any>>;
    let isTouched$: Observable<boolean>;

    onMount(() => {
        const formControl = getFormController();
        formField$ = formControl.getFieldState$();
        isTouched$ = formControl.isTouched$();
    });


    function submitFieldValueIfValid(formFieldState: SvelteFormsField<any>) {
        if (formFieldState.valid) {
            dispatch('field-value-submit');
        }
    }

    function showValidationError(fieldState: SvelteFormsField<any>, show: boolean): boolean {
        if (fieldState) {
            return fieldState.invalid && show;
        }
        return false;
    }

    export function getFormController(): FormController<any> {
        return editorController.getFormController();
    }

    // hack to silence svelte-check
    function getRecordId(value): string {
        if (value.id) {
            return value.id;
        }
        return '';
    }
</script>

<template>
    <form class="field-value-form"
          class:has-error={showValidationError($formField$, $isTouched$)}
          class:has-not-error={!showValidationError($formField$, $isTouched$)}>
        {#if showRecordLink}
            <!-- TODO: tohle delat pomoci slotu z vnejsku, az bude kp-record-editation ve svelte -->
            <a href="/records/{getRecordId(field.value)}" target="_blank" rel="noreferrer">{field.raw}</a>
        {/if}
        <div class="value-editor-container">
            <KpValueEditorForceSettings {forceSettings}>
                <KpValueEditor type={fieldOrSubfieldType.editor.type}
                               options={fieldOrSubfieldType.editor.options}
                               validations={fieldOrSubfieldType.editor.validations}
                               bind:model={field.value}
                               editorId={field.id}
                               editorName='field-input'
                               size={editorSize}
                               {formControlOptions}
                               on:model-change={() => submitFieldValueIfValid($formField$)}
                               bind:this={editorController}/>
            </KpValueEditorForceSettings>
        </div>
    </form>
</template>

<style lang="less">
    .field-value-form {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .value-editor-container {
            flex-grow: 1;
        }
    }
</style>
